export default __webpack_public_path__ + "static/media/bg-md.dc6fdec2.jpg";